__turbopack_context__.v({
  "newMedicalAvantiSubTitle": "xE83Sq_newMedicalAvantiSubTitle",
  "newMedicalStaysureSubTitle": "xE83Sq_newMedicalStaysureSubTitle",
  "question_Paragraph_wrapper": "xE83Sq_question_Paragraph_wrapper",
});
